import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class RoleApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/role/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/role/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getRoleList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/role?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getRole(id, token ) {  
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/role/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(role, token ) {          
      let roleEnvio = Object.assign({}, role);
		let comando="POST";
		if (roleEnvio.id > 0) {
			comando="PUT";			
		} 
		roleEnvio=JSON.stringify(roleEnvio);
		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/role/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: roleEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    static getRoleCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/role/combo",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}